import { useContext } from 'react';
import RichTextContext from '../../context';
import { drefImages } from './consts';

const keys = Object.keys(drefImages);

export const T2IconCheck = (attr) => +attr.t === 12 && keys.includes(attr?.v);

export default function T2Icon(props) {
  const richTextContex = useContext(RichTextContext);
  const imgInfo = drefImages[props.v];
  const height = richTextContex.lineHeight * 0.6;
  const width = height * imgInfo.ratio;

  return (
    <img
      src={imgInfo.url}
      style={{
        display: 'inline-block',
        height: height,
        width: width,
        marginLeft: 4,
      }}
    />
  );
}
